import { useAuthStore } from '../store/authStore';
import { getTenantTerminology, type TenantTerminology } from '@matix/utils';

/**
 * Returns the current KDS user's tenant slug, or null if unauthenticated.
 * Mirrors the admin app's hook — same logic, just reads from the service
 * app's auth store.
 */
export function useTenantSlug(): string | null {
  const state = useAuthStore((s) => s.state);
  if (state.kind === 'session') return state.data.session.tenant_slug;
  return null;
}

/** Resolved per-tenant terminology (e.g. table → sun bed for villashams). */
export function useTenantTerminology(): TenantTerminology {
  return getTenantTerminology(useTenantSlug());
}
